import type { AppContext } from 'next/app';
import { toHandler } from './handler';
import { ShareType } from './shareTypes';

export const toLambdas = async (context: AppContext) => {
  const shareClassMetadata = await toHandler(context.ctx, ShareType.ClassDetails);
  const shareTagsMetadata = await toHandler(context.ctx, ShareType.TagDetails);
  const shareScheduledEventDetails = await toHandler(
    context.ctx,
    ShareType.ScheduleEventDetails,
  );
  const shareDetailedWorkoutMetadata = await toHandler(
    context.ctx,
    ShareType.DetailedWorkoutDetails,
  );
  const shareInviteDetailsMetadata = await toHandler(
    context.ctx,
    ShareType.InviteDetails,
  );
  const shareGenericWorkoutDetailsMetadata = await toHandler(
    context.ctx,
    ShareType.GenericWorkoutDetails,
  );

  const shareMetadata = [
    ...(shareClassMetadata || []),
    ...(shareTagsMetadata || []),
    ...(shareScheduledEventDetails || []),
    ...(shareDetailedWorkoutMetadata || []),
    ...(shareInviteDetailsMetadata || []),
    ...(shareGenericWorkoutDetailsMetadata || []),
  ];

  return shareMetadata;
};
